export const TOAST_POSITION = "top-right";

export const TOAST_TYPE_SUCESS = "success";

export const TOAST_TYPE_WARNING = "warning";

export const TOAST_TYPE_ERROR = "error";

export const TOAST_HEADING_SUCCESS = "Success";

export const TOAST_HEADING_WARNING = "Warning";

export const LOGIN = "login";

export const CONTACT = "contact";

export const EXPORTUSER = "exportUser";

export const REACT_APP_API_URL = process.env.REACT_APP_DOMAIN === "development"
    ? window.location.protocol + "//" + window.location.hostname + ":5000/"
    : window.location.origin + "/";